

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// REQUESTREAPPROVAL
// REQUESTREAPPROVAL

const REQUESTREAPPROVAL = createAsyncThunk(
  "requestReapproval/requestReapproval",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const requestReapprovalSlice = createSlice({
  name: "requestReapprovalSlice",
  initialState: {
    requestReapproval: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfrequestReapproval: (state) => {
        state.requestReapproval.loading = false
        state.requestReapproval.error = false
        state.requestReapproval.data = []
        state.requestReapproval.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(REQUESTREAPPROVAL.fulfilled, (state, action) => {
      state.requestReapproval = {
        ...state.requestReapproval,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REQUESTREAPPROVAL.pending, (state, action) => {
      state.requestReapproval = {
        ...state.requestReapproval,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REQUESTREAPPROVAL.rejected, (state, action) => {
      state.requestReapproval = {
        ...state.requestReapproval,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const requestReapprovalAction = {
  REQUESTREAPPROVAL,
};

export { requestReapprovalAction };
export default requestReapprovalSlice.reducer;
export const {setInitialStateOfrequestReapproval} = requestReapprovalSlice.actions
